import { registerDestructor } from '@ember/destroyable';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import GeneralTablesCellsTdLinkBase from 'lumen/components/general/tables/cells/td-link-base';
import getElement from 'lumen/modifiers/get-element';

interface ParityTablesCellsTdProofSignature {
  Args: {
    cellData: {
      formattedValue: string;
      isScreenshotSupported: boolean;
      onDoubleClick: () => void;
      redirectUrl: string;
    };
  };
}

export default class ParityTablesCellsTdProof extends Component<ParityTablesCellsTdProofSignature> {
  @action setCellElement(element: HTMLElement): void {
    const cellElement = element.parentElement;

    cellElement?.addEventListener('dblclick', this.args.cellData.onDoubleClick);
    registerDestructor(this, () => {
      cellElement?.removeEventListener(
        'dblclick',
        this.args.cellData.onDoubleClick,
      );
    });
  }

  <template>
    <span {{getElement this.setCellElement}}>
      {{#if @cellData.isScreenshotSupported}}
        {{#if @cellData.redirectUrl}}
          <a
            class="prism-link text-200--medium truncate"
            href={{@cellData.redirectUrl}}
            rel="noopener noreferrer"
            target="_blank"
          >
            <GeneralTablesCellsTdLinkBase @cellData={{@cellData}} />
          </a>
        {{else}}
          <span class="text-200--regular prism-link--disabled">
            <GeneralTablesCellsTdLinkBase @cellData={{@cellData}} />
          </span>
        {{/if}}
      {{else}}
        <div class="text-200--regular truncate">
          {{@cellData.formattedValue}}
        </div>
      {{/if}}
    </span>
  </template>
}
